exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.ng-invalid.ng-touched {\n    border: 1px red solid;\n}\n\nselect.ng-invalid.ng-touched {\n    border: 1px red solid;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/haulers-edit/haulers-edit.component.css
// module id = ../../../../../src/app/haulers/haulers-edit/haulers-edit.component.css
// module chunks = main